export default "__VITE_ASSET__KQCqf7xw__"